import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-inline-success",
    styleUrls: ["./inline-success.component.scss"],
    templateUrl: "./inline-success.component.html",
    standalone: false
})
export class FUIInlineSuccessComponent {
    @Input() title: string;
    @Input() titleParams: any = {};
    @Input() message: string;
    @Input() messageParams: any = {};
}
